<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <app-section-loader :status="loading.getListContracts"></app-section-loader>
                    <v-card-title>
                        <v-layout row>
                            <v-flex auto class="pa-0">
                                <h4>BẢNG HỢP ĐỒNG THUÊ PHÒNG</h4>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout row justify-end>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tìm theo"
                                    :disabled="loading.submit"
                                    v-model="search_type"
                                    :items="list_search_type"
                                    prepend-icon="visibility"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3 class="pb-0">
                                <v-btn @click="getTablesData" color="primary" dark class="mt-3 mb-0">
                                    Tìm kiếm
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 md3 class="pb-0">
                                <v-btn @click="exportCSV" color="green" dark class="mt-3 mb-0 ml-2">
                                    <v-icon left>file_download</v-icon>
                                    Xuất Excel
                                </v-btn>
                                <export-csv-button
                                    :trigger="export_csv.trigger"
                                    :title="export_csv.title"
                                    :rows="export_csv.rows"
                                ></export-csv-button>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card class="mt-4">
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                            :loading="loading.getListContracts"
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                        <template #items="props">
                            <tr style="cursor: pointer" @click="showDetail(props.item)">
                                <td class="text-center">{{ props.item.room_id }}</td>
                                <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                                <td class="text-center">{{ props.item.room_price | formatNumber }}</td>
                                <td class="text-center">{{ (props.item.room_price_standard ? props.item.room_price_standard : '') | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.latest_increase_date ? props.item.latest_increase_date : '' | formatTimeServer }}</td>
                                <td class="text-center">{{ props.item.deposit_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.customer_count }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.date_in | formatTimeServer }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.date_schedule_in | formatTimeServer }}</td>
                                <td class="text-center">{{ props.item.water_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.trash_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.internet_price | formatNumber }}</td>
                                <td class="text-center">{{ props.item.motorbike_count }}</td>
                                <td class="text-center">{{ props.item.bike_count }}</td>
                                <!-- <td class="text-center">{{ props.item.parking_price | formatNumber }}</td> -->
                                <td class="text-center">{{ (props.item.washing_machine_total_price ? props.item.washing_machine_total_price : '') | formatNumber }}</td>
                                <td class="text-center">
                                    {{ props.item.is_included_air_conditioner
                                        ? 'Trả trước'
                                        : props.item.air_conditioner_price
                                            ? 'Trả sau'
                                            : 'Không xài'
                                    }}
                                </td>
                                <td class="text-center">{{ (props.item.air_conditioner_price && props.item.air_conditioner_price > 0 ? props.item.air_conditioner_price : '') | formatNumber }}</td>
                                <td class="text-center" @click.stop>
                                    <div class="d-flex justify-center">
                                        <v-checkbox
                                            class="mt-0"
                                            :disabled="user_role !== 'admin' && user_role !== 'manager'"
                                            v-if="!props.item.loading"
                                            color="primary"
                                            v-model="props.item.has_temporary_residence"
                                            hide-details
                                            @change="updateTamTru(props.item)"
                                        ></v-checkbox>
                                        <v-progress-circular v-else indeterminate color="primary" :size="24"></v-progress-circular>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="dialogDetail" max-width="80%">
        <app-card>
            <app-section-loader :status="loading.getDetail"></app-section-loader>
            <h4 class="mb-4 mt-2">Chi tiết phòng số: {{ chosen_contract.room_id }}</h4>
            <v-data-table :headers="detail_headers" :items="chosen_contract.customers" item-key="id">
                <template #headers="props">
                    <tr>
                        <th class="text-xs-center fw-bold" v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template #items="props">
                    <tr>
                        <td class="text-center text-no-wrap">{{ props.item.name }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.phone }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.motorbike ? props.item.motorbike : 'Không có' }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.bike ? 'Có' : 'Không có' }}</td>
                    </tr>
                </template>
            </v-data-table>
        </app-card>
    </v-dialog>
</div>
</template>

<script>
import api from "Api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer } from 'Helpers'
import { list_building } from 'Constants/db-config'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton.vue'

export default {
    name: 'contract',
    components: {
        ExportCsvButton
    },
    data() {
        return {
            search:'',
            search_type: 'roomId',
            headers: [
                { text: "Số phòng", align: "center", sortable: false, value: "room_id" },
                // { text: "Mã khách hàng", align: "center", value: "customer_code" },
                { text: "Họ và tên", align: "left", value: "name" },
                { text: "Giá phòng cho thuê", align: "center", value: "room_price" },
                { text: "Giá chuẩn", align: "center", value: "room_price_standard" },
                { text: "Ngày tăng giá gần nhất", align: "center", value: "latest_increase_date" },
                { text: "Tiền cọc", align: "center", value: "deposit" },
                { text: "Số người ở", align: "center", value: "customer_count" },
                { text: "Ngày dọn vào", align: "center", value: "date_in" },
                { text: "Ngày hẹn nhận phòng", align: "center", value: "date_schedule_in" },
                { text: "Tiền nước", align: "center", value: "water_price" },
                { text: "Tiền rác", align: "center", value: "trash_price" },
                { text: "Tiền Internet", align: "center", value: "internet_price" },
                { text: "Số lượng xe máy", align: "center", value: "motorbike_count" },
                { text: "Số lượng xe đạp", align: "center", value: "bike_count" },
                // { text: "Tiền gửi xe", align: "center", value: "parking_price" },
                { text: "Máy giặt", align: "center", value: "washing_machine_price" },
                { text: "Loại máy lạnh", align: "center", value: "is_included_air_conditioner" },
                { text: "Giá máy lạnh", align: "center", value: "air_conditioner_price" },
                { text: "Tạm trú", align: "center", sortable: false, value: "has_temporary_residence" },
            ],
            detail_headers: [
                { text: "Tên", align: "center", sortable: false, value: "name" },
                { text: "SDT", align: "center", sortable: false, value: "name" },
                { text: "Xe máy", align: "center", sortable: false, value: "motorbike" },
                { text: "Xe đạp", align: "center", sortable: false, value: "bike" }
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: 'BN',
            items: [],
            loading: {
                submit: false,
                getDetail: false,
                getListContracts: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            dialogDetail: false,
            chosen_contract: {},
            export_csv: {
                loading: false,
                trigger: false,
                title: "BangHopDong",
                rows: []
            },
        };
    },
    computed: {
        user_role() {
            return this.$store.state.auth.role;
        }
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData: async function () {
            this.loading.getListContracts = true
            const params = {
                building: this.chosen_building,
                [this.search_type]: this.search,
                contractValid: true,
                customerValid: true,
                deviceValid: true
            }
            const query = buildParamQuery(params)
            let data = await api.getListContracts(query)
            this.loading.getListContracts = false
            this.items = data.data.contracts.map( contract => this.handleData(contract))
        },
        handleData: function (data){
            // Số người ở hiện tại (đã được filter từ API với customerValid: true)
            data.customer_count = data.listCustomers.length
            // Số xe máy hiện tại (chỉ đếm devices valid với type = 'MB')
            data.motorbike_count = data.devicesInfo.filter( device => device.type === 'MB' && device.is_valid === true).length
            data.bike_count = data.devicesInfo.filter( device => device.type === 'B' && device.is_valid === true).length
            data.customers = data.listCustomers.map( customer => {
                const motorbike = data.devicesInfo.find(device => device.type === 'MB' && device.customer_id === customer.customer_id )
                const bike = data.devicesInfo.find(device => device.type === 'B' && device.customer_id === customer.customer_id )
                customer.bike = !!bike
                customer.motorbike = motorbike ? motorbike.name : false
                return customer
            })
            const internet = data.devicesInfo.find( device => device.type === 'INTERNET')
            data.internet_price = internet ? internet.price : 0 
            // Máy giặt: tính theo số người ở = giá máy giặt * số người ở hiện tại
            // washing_machine_price: giữ nguyên giá gốc từ contract (giá cho 1 người)
            // washing_machine_total_price: tổng tiền thật sự charge (đã nhân với số người ở)
            const washingMachine = data.devicesInfo.find( device => device.type === 'WM' && device.is_valid === true)
            if (washingMachine && data.washing_machine_price && data.washing_machine_price > 0) {
                // Tính tổng tiền máy giặt = giá cho 1 người * số người ở hiện tại
                data.washing_machine_total_price = data.washing_machine_price * data.customer_count
            } else {
                data.washing_machine_total_price = null
            }
            return data
        },
        showDetail: async function (contract){
            this.dialogDetail = true
            this.chosen_contract = contract
        },
        exportCSV: function() {
            this.export_csv.rows = this.items.map(contract => ({
                'Số phòng': contract.room_id,
                'Họ và tên': contract.name,
                'Giá phòng cho thuê': contract.room_price,
                'Giá chuẩn': contract.room_price_standard || '',
                'Ngày tăng giá gần nhất': contract.latest_increase_date ? new Date(contract.latest_increase_date).toLocaleDateString('vi-VN') : '',
                'Tiền cọc': contract.deposit_price,
                'Số người ở': contract.customer_count,
                'Ngày dọn vào': contract.date_in ? new Date(contract.date_in).toLocaleDateString('vi-VN') : '',
                'Ngày hẹn nhận phòng': contract.date_schedule_in ? new Date(contract.date_schedule_in).toLocaleDateString('vi-VN') : '',
                'Tiền nước': contract.water_price,
                'Tiền rác': contract.trash_price,
                'Tiền Internet': contract.internet_price,
                'Số lượng xe máy': contract.motorbike_count,
                'Số lượng xe đạp': contract.bike_count,
                'Máy giặt': contract.washing_machine_total_price || '',
                'Loại máy lạnh': contract.is_included_air_conditioner ? 'Trả trước' : (contract.air_conditioner_price ? 'Trả sau' : 'Không xài'),
                'Giá máy lạnh': contract.air_conditioner_price || '',
                'Tạm trú': contract.has_temporary_residence ? 'Có' : 'Không'
            }));
            this.export_csv.trigger = !this.export_csv.trigger;
        },
        updateTamTru: async function (contract) {
            this.$set(contract, 'loading', true);
            const data = await api.updateContract(contract._id, { has_temporary_residence: contract.has_temporary_residence });
            this.$set(contract, 'loading', false);
            if (data.status === 200) {
                // success
            } else {
                // revert and show error
                this.$set(contract, 'has_temporary_residence', !contract.has_temporary_residence);
                swal.fire('Thất bại', data.message || 'Cập nhật thất bại', 'error');
            }
        }
    }
};
</script>
